"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _CampaignQuestion = _interopRequireDefault(require("../../containers/CampaignCreator/CampaignQuestion"));

var _semanticUiReact = require("semantic-ui-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Category = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Category, _React$Component);

  function Category() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      active: false
    });

    _defineProperty(_assertThisInitialized(_this), "toggleActive", function (e) {
      _this.setState(_extends({}, _this.state, {
        active: !_this.state.active
      }));
    });

    return _this;
  }

  var _proto = Category.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.props.shouldReset) {
      this.setState(_extends({}, this.state, {
        active: false
      }));
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        category = _this$props.value,
        hasAccess = _this$props.hasAccess,
        noAccessAction = _this$props.noAccessAction;
    var active = this.state.active;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", {
      className: "characteristics-filter-category"
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Accordion, {
      active: active ? 'true' : 'false',
      className: "characteristics-filter__accordion"
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Accordion.Title, {
      className: "characteristics-filter-category__title"
    }, /*#__PURE__*/React.createElement("button", {
      onClick: this.toggleActive,
      className: "characteristics-filter__button"
    }, /*#__PURE__*/React.createElement("h3", null, category.categoryLabel), /*#__PURE__*/React.createElement(_semanticUiReact.Icon, {
      className: "characteristics-filter__button-icon",
      name: "" + (active ? 'minus square' : 'plus square')
    }))), /*#__PURE__*/React.createElement(_semanticUiReact.Accordion.Content, {
      active: active
    }, /*#__PURE__*/React.createElement("ul", {
      className: "characteristics-filter-category__list"
    }, category && category.questions && category.questions.map(function (question, key) {
      return /*#__PURE__*/React.createElement(_CampaignQuestion["default"], {
        value: question,
        key: key,
        shouldReset: _this2.props.shouldReset,
        hasAccess: hasAccess,
        noAccessAction: noAccessAction,
        categoryLabel: category.categoryLabel
      });
    }))))), /*#__PURE__*/React.createElement("hr", {
      className: "characteristics-filter-category__divider"
    }));
  };

  return Category;
}(React.Component);

var _default = Category;
exports["default"] = _default;